module.exports = __webpack_public_path__ + "static/born-to-run-9a76ade7f6759381096aaa28a6f92d89.jpg";